import { z } from 'zod';
export const upsertTurnDetectionConfigSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1),
    model_type: z.string(),
    unlikely_threshold: z.number().nullable(),
    min_endpointing_delay: z.number(),
    max_endpointing_delay: z.number(),
    min_response_delay: z.number(),
    max_response_delay: z.number(),
    interruption_threshold: z.number(),
    turn_taking_aggressiveness: z.number(),
    allow_first_phrase_interruptions: z.boolean(),
    min_endpointing_delay_on_interruption: z.number().nullable(),
    min_time_for_interruption_endpointing_delay: z.number().nullable(),
    agentId: z.string(),
});
